import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { useNavigate, useParams } from 'react-router-dom'
import SmsTemplateForm from './SmsTemplateForm'
import usePermissions from '@/hooks/usePermissions'
import Redirect from '@/components/Redirect'

const mapStateToProps = () => ({})

const SmsTemplateCreate = ({ dispatch }) => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const routeParams = useParams()
  const { type } = routeParams

  const canCreate = usePermissions(
    type === 'system' ? 'smsTempSystem_create' : 'smsTempPerson_create',
  )

  const onSubmit = payload => {
    dispatch({
      type: 'smsTemplate/createSmsTemplate',
      payload,
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: { message: t('messages.sms_template_created'), severity: 'success' },
        })
        navigate(`/phish_template_sms/${type}`, { replace: true })
      },
    })
  }

  if (!canCreate) return <Redirect />

  return <SmsTemplateForm onSubmit={onSubmit} type={type} />
}

export default connect(mapStateToProps)(SmsTemplateCreate)
